import { render } from "./FlipClock.vue?vue&type=template&id=b889019a&scoped=true"
import script from "./FlipClock.vue?vue&type=script&lang=js"
export * from "./FlipClock.vue?vue&type=script&lang=js"

import "./FlipClock.vue?vue&type=style&index=0&id=b889019a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b889019a"]])

export default __exports__